// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3dHjh","label":"Category_label__US5fc","content":"Category_content__3xoKx","header":"Category_header__1b1yB","location":"Category_location__1Wni8"};